// src/layout/Footer.tsx
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white p-2 text-dark mt-auto border-t">
      <div className="container mx-auto flex justify-start">
        <p className="text-sm font-medium text-center text-gray-400">
          &copy; UA Canada. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
